import api from 'shared/api';

export const patchUser = (userId, data) => {
  const url = `/api/v1/users/${userId}/`;
  return api.patch(url, data);
};
